export default "__VITE_ASSET__CSVqLjwe__"